import { environment } from 'src/environments/environment';


export function jwtOptionsFactory() {
  return {
    tokenGetter: () => {
      return window.sessionStorage.getItem('lccore_token');
    },
    allowedDomains: environment.whitelistedDomains
  };
}
